import React from "react"
import { createPortal } from "react-dom"
import DfbAlert from "../ui-kit/dfb_alert"

const CAlert = props => {
  return createPortal(
    <DfbAlert {...props} />,
    document.getElementById("alerts")
  )
}

export default CAlert
